
import { mapState } from 'vuex'

export default {
  props: ['step'],
  data () {
    return {
      tabs: [
        {
          to: '/checkout/order',
          name: 'Order'
        },
        {
          to: '/checkout/data',
          name: 'Your data'
        },
        {
          to: '/checkout/payment',
          name: 'Payment'
        },
        {
          to: '/checkout/download',
          name: 'Download'
        }
      ],
      activeStyles: ['active', 'disabled']
    }
  },
  computed: {
    ...mapState({ order: state => state.checkout.order }),
    paymentAvailable () {
      return this.order && this.order.status === 'NEW' && this.order.total_price > 0
    }
  }
}
